<script setup lang="ts">
import BaseInput, { InputState } from '@/atoms/BaseInput.vue';
import LocalIcon from '@/atoms/LocalIcon.vue';
import { ENTER_KEY_HINTS, EnterKeyHint } from '@/constant/inputs';
import { ref } from 'vue';

export type SearchInputProps = {
  id: string;
  placeholder?: string;
  class?: string;
  disabled?: boolean;
  state?: InputState;
  enterkeyhint?: EnterKeyHint;
};

const props = withDefaults(defineProps<SearchInputProps>(), {
  placeholder: 'Rechercher',
  state: 'default',
  enterkeyhint: ENTER_KEY_HINTS.search,
});

const state = ref<InputState>(props.state);
const value = defineModel<string>();

const onEnter = (e: KeyboardEvent) => {
  if (
    props.enterkeyhint === ENTER_KEY_HINTS.done ||
    props.enterkeyhint === ENTER_KEY_HINTS.search
  ) {
    (e.target as HTMLInputElement)?.blur();
  }
};

const setFocused = () => {
  if (state.value !== 'disabled') {
    state.value = 'focused';
  }
};

const setDefault = () => {
  if (state.value !== 'disabled') {
    state.value = 'default';
  }
};
</script>

<template>
  <BaseInput type="text" :class="props.class" :state="state" :id="id">
    <template #left-slot>
      <LocalIcon name="search" size="small" class="text-tertiary" />
    </template>
    <input
      :id="id"
      type="text"
      class="w-full h-full font-inter text-current"
      :disabled="state === 'disabled'"
      :placeholder="placeholder"
      v-model="value"
      @blur="setDefault"
      @click="setFocused"
      @focusin="setFocused"
      @keydown.enter="onEnter"
      :enterkeyhint="enterkeyhint"
    />
  </BaseInput>
</template>
